export default __webpack_public_path__ + "static/cta-subscribe-bg-mobile-91e4608dac5134b33861c8ee976ee5f0.png";